/*
 * RESPONSE ERRORS FROM django_backend
 * The idea is to prevent a lot of text being sent
 * and then being parsed (which can lead to incorrect
 * matches). Instead, we send "error codes" for easy
 * matching :).
 * IMPORTANT: These constants should match the ones
 * in django_backend
 */
export const COMPANY_INACTIVE = 'COMPANY_INACTIVE';
export const COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND';
export const EMAIL_IS_USED = 'EMAIL_IS_USED';
export const REGISTRATION_ERROR = 'REGISTRATION_ERROR';
export const IS_INELIGIBLE = 'IS_INELIGIBLE';
